<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Concession Item Sales") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :multiple="false"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- User Filter -->
            <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
                       <div class="dropdown-curve-container">
                         <label
                           :class="
                             selectedUsers && selectedUsers.length > 0
                               ? 'shift-up'
                               : 'font-weight-bold'
                           "
                           >{{ $t("select") }} {{ $t("users") }}</label
                         >
                         <multiselect
                           :options="Users"
                           v-model="selectedUsers"
                           placeholder=""
                           label="username"
                           :multiple="true"
                           :close-on-select="true"
                           track-by="user_id"
                         ></multiselect>
                       </div>
                     </div>

          <!-- Store Filter -->
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedStores && selectedStores.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{
                  selectedStores && selectedStores.length > 0
                    ? $t("Store")
                    : $t("All Store")
                }}</label
              >
              <multiselect
                :options="storeList"
                v-model="selectedStores"
                :searchable="true"
                label="sm_store_name"
                track-by="sm_id"
                :multiple="true"
                :close-on-select="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <!-- Payment Type Filter -->
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedPaymentModes && selectedPaymentModes.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("All Payment Mode") }}</label
              >
              <multiselect
                :options="paymentList"
                v-model="selectedPaymentModes"
                :searchable="true"
                label="pm_payment_mode"
                track-by="pm_id"
                :multiple="true"
                :close-on-select="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

            <!-- show time filter -->
          <div class="position-relative col-lg-3 col-xl-2 mb-2">
            <vue-timepicker
              manual-input
              v-model="start_time"
              id="starttime"
              name="starttime"
              :placeholder="$tc('starttime')"
              format="HH:mm"
              class="time_picker"
              input-width="100%"
              auto-scroll
              lazy
            ></vue-timepicker>
          </div>

          <div class="position-relative col-lg-3 col-xl-2 mb-2">
            <vue-timepicker
              manual-input
              v-model="end_time"
              id="endtime"
              name="endtime"
              :placeholder="$tc('endtime')"
              format="HH:mm"
              class="time_picker"
              input-width="100%"
              auto-scroll
              lazy
            />
          </div>
          <!-- show time filter -->

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getConcessionItemSales((isExcel = 'N'))"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            v-if="concessionItemRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getConcessionItemSales((isExcel = 'Y'))"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getConcessionItemSales((isExcel = 'N'), 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightblue font-weight-bold text-light">
            <th>Category Name</th>
            <th>Item Code</th>
            <th>UOM</th>
            <th>Quantity</th>
            <th>Discount</th>
            <th>Net</th>
            <th>Tax</th>
            <th>Sales Value</th>
            <th>Advance Sales</th>
            <th>Cost(Excl. Tax)</th>
            <th>Margin(On Net)</th>
            <th>% Of Total Sales</th>
          </thead>
          <tbody v-if="concessionItemRecords.length > 0">
            <template
              v-for="(concessionItem, concessionIndex) in concessionItemRecords"
            >
              <tr
                :key="concessionIndex + 'CinemaName'"
                class="bg-lightgrey font-weight-bold"
              >
                <td colspan="13" class="text-left">
                  {{ concessionItem.cinema_name }}
                </td>
              </tr>
              <template
                v-for="(
                  concessionCategory, concessionCategoryIndex
                ) in concessionItem.locationArr"
              >
                <tr>
                  <td colspan="13 " class="font-weight-bold text-left">
                    Location :
                    {{
                      concessionCategory
                        ? concessionCategory.location_name
                          ? concessionCategory.location_name
                          : "-"
                        : ""
                    }}
                  </td>
                </tr>
                <template
                  v-for="(
                    concessionCategoryItems, concessionCategoryItemsIndex
                  ) in concessionCategory.categoryArr"
                >
                  <td class="text-left font-weight-bold" colspan="13">
                    {{ concessionCategoryItems.category_name }}
                  </td>

                  <tr
                    v-for="(
                      items, itemsIndex
                    ) in concessionCategoryItems.categoryData"
                  >
                    <td class="text-left">{{ items.fst_item_name }}</td>
                    <td class="text-left">{{ items.item_code }}</td>
                    <td class="text-left">Each</td>
                    <td class="text-right">{{ items.quantity }}</td>
                    <td class="text-right">
                      {{ items.discount ? currFormat(items.discount) : 0 }}
                    </td>
                    <td class="text-right">
                      {{ items.net_amount ? currFormat(items.net_amount) : 0 }}
                    </td>
                    <td class="text-right">
                      {{ items.tax ? currFormat(items.tax) : 0 }}
                    </td>
                    <td class="text-right">
                      {{
                        items.sales_value ? currFormat(items.sales_value) : 0
                      }}
                    </td>
                    <td class="text-right">0.00</td>
                    <td class="text-right">
                      {{ items.net_amount > 0 ? currFormat(items.cost) : 0 }}
                    </td>
                    <td class="text-right">
                      {{ items.margin ? currFormat(items.margin) : 0 }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(items.percent_of_total_sales) }}%
                    </td>
                  </tr>
                  <tr
                    class="font-weight-bold bg-lightgrey"
                    :key="concessionCategoryItemsIndex + 'categoryTotal'"
                  >
                    <td colspan="3">Category Total:</td>
                    <td class="text-right">
                      {{
                        concessionCategoryItems.categoryData.reduce(
                          (acc, { quantity }) => {
                            return acc + quantity;
                          },
                          0
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          concessionCategoryItems.categoryData.reduce(
                            (acc, { discount }) => {
                              return acc + discount;
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          concessionCategoryItems.categoryData.reduce(
                            (acc, { net_amount }) => {
                              return acc + net_amount;
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          concessionCategoryItems.categoryData.reduce(
                            (acc, { tax }) => {
                              return acc + tax;
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          concessionCategoryItems.categoryData.reduce(
                            (acc, { sales_value }) => {
                              return acc + sales_value;
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <td class="text-right">{{ currFormat(0) }}</td>
                    <td class="text-right">
                      {{
                        currFormat(
                          concessionCategoryItems.categoryData.reduce(
                            (acc, { cost }) => {
                              return acc + cost;
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          concessionCategoryItems.categoryData.reduce(
                            (acc, { margin }) => {
                              return acc + margin;
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          concessionCategoryItems.categoryData.reduce(
                            (acc, { percent_of_total_sales }) => {
                              return acc + percent_of_total_sales;
                            },
                            0
                          ) / concessionCategoryItems.categoryData.length
                        )
                      }}
                    </td>
                  </tr>
                </template>

                 <tr class="font-weight-bold" style="background-color: #c8d8e8;">
    <td class="text-left" colspan="3">
      Location Total: {{ concessionCategory ? concessionCategory.location_name || "-" : "" }}
    </td>
    <td class="text-right">
      {{
        concessionCategory.categoryArr.reduce((locAcc, category) =>
          locAcc + category.categoryData.reduce((acc, { quantity }) => acc + quantity, 0)
        , 0)
      }}
    </td>
    <td class="text-right">
      {{
        currFormat(
          concessionCategory.categoryArr.reduce((locAcc, category) =>
            locAcc + category.categoryData.reduce((acc, { discount }) => acc + discount, 0)
          , 0)
        )
      }}
    </td>
    <td class="text-right">
      {{
        currFormat(
          concessionCategory.categoryArr.reduce((locAcc, category) =>
            locAcc + category.categoryData.reduce((acc, { net_amount }) => acc + net_amount, 0)
          , 0)
        )
      }}
    </td>
    <td class="text-right">
      {{
        currFormat(
          concessionCategory.categoryArr.reduce((locAcc, category) =>
            locAcc + category.categoryData.reduce((acc, { tax }) => acc + tax, 0)
          , 0)
        )
      }}
    </td>
    <td class="text-right">
      {{
        currFormat(
          concessionCategory.categoryArr.reduce((locAcc, category) =>
            locAcc + category.categoryData.reduce((acc, { sales_value }) => acc + sales_value, 0)
          , 0)
        )
      }}
    </td>
    <td class="text-right">0.00</td>
    <td class="text-right">
      {{
        currFormat(
          concessionCategory.categoryArr.reduce((locAcc, category) =>
            locAcc + category.categoryData.reduce((acc, { cost }) => acc + cost, 0)
          , 0)
        )
      }}
    </td>
    <td class="text-right">
      {{
        currFormat(
          concessionCategory.categoryArr.reduce((locAcc, category) =>
            locAcc + category.categoryData.reduce((acc, { margin }) => acc + margin, 0)
          , 0)
        )
      }}
    </td>
    <td class="text-right">
      {{
        currFormat(
          concessionCategory.categoryArr.reduce((locAcc, category) =>
            locAcc + category.categoryData.reduce((acc, { percent_of_total_sales }) => acc + percent_of_total_sales, 0)
          , 0)
        )
      }}%
    </td>
  </tr>


              </template>
              <tr class="bg-lightgrey font-weight-bold">
                <td class="text-left" colspan="3">
                  Total for Cinema: {{ concessionItem.cinema_name }}
                </td>
                <td class="text-right">
                  {{ concessionItem.cinemaGrandTotal.quantityTotal }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(concessionItem.cinemaGrandTotal.discountTotal)
                  }}
                </td>
                <td class="text-right">
                  {{ currFormat(concessionItem.cinemaGrandTotal.netTotal) }}
                </td>
                <td class="text-right">
                  {{ currFormat(concessionItem.cinemaGrandTotal.taxTotal) }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(concessionItem.cinemaGrandTotal.salesValueTotal)
                  }}
                </td>
                <td class="text-right">0.00</td>
                <td class="text-right">
                  {{ currFormat(concessionItem.cinemaGrandTotal.costTotal) }}
                </td>
                <td class="text-right">
                  {{ currFormat(concessionItem.cinemaGrandTotal.marginTotal) }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      concessionItem.cinemaGrandTotal.percent_total_salesTotal
                    )
                  }}%
                </td>
              </tr>
            </template>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left" colspan="3">Grand Total</td>
              <td class="text-right">{{ grandTotal.quantity_Gtotal }}</td>
              <td class="text-right">
                {{ currFormat(grandTotal.discount_Gtotal) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.net_Gtotal) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.tax_Gtotal) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.salesValue_Gtotal) }}
              </td>
              <td class="text-right">0.00</td>
              <td class="text-right">
                {{ currFormat(grandTotal.cost_Gtotal) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.margin_Gtotal) }}
              </td>
              <td class="text-right">{{ currFormat(100) }}%</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="13">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    VueTimepicker
  },
  data() {
    return {
       Users: [],
      selectedUsers: [],
      storeList: [],
      selectedStores: [],
      paymentList: [],
      selectedPaymentModes: [],
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      concessionItemRecords: [],
      excelFilePath: "",
      grandTotal: {},
       end_time: "",
            start_time: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.getUsers();
    this.getPaymentTypes();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
       async getUsers(index) {
          try {
            const response = await MasterService.GetActiveList({
              tableName: "users",
              is_active: "Y",
            });
            const { data } = response;
            // console.log("data",data)
            if (data.status && data.Records.length > 0) {
               this.Users = data.Records.filter(
    (user) => user.role_id == 8 || user.role_id == 4
  );
console.log("Users", this.Users.length);
            } else {
              console.log("show error:", data.message);
            }
          } catch (error) {
            this._CatchError(error);
          }
        },
    getPaymentTypes() {
      MasterService.GetActiveList({
        tableName: "ms_payment_modes",
        pm_is_active: "Y",
      })
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.paymentList = (data.Records || []).sort((a, b) =>
              (a.pm_payment_mode || "").localeCompare(b.pm_payment_mode || "")
            );
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(() => {
          this.$toasted.show("Opps! Something went wrong");
        });
    },
    getStockManagementData(cinema_id) {
      if (!cinema_id) {
        this.storeList = [];
        this.selectedStores = [];
        return;
      }
      PosFnbService.GetStoreManagementDetails({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.Records && data.Records.length) {
            this.storeList = [...data.Records];
          } else {
            this.storeList = [];
          }
          this.selectedStores = [];
        })
        .catch(this._CatchError);
    },
    onChangeDate: function (e, type) {
      if (type == 'from') {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaName = event.cine_address;
      this.$store.dispatch("selectDropdownCinema", event);
      this.getStockManagementData(event.cine_id);
    },
    getConcessionItemSales(isExcel, isPdf = "N") {
      if (isExcel == "N") {
        this.concessionItemRecords = [];
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }

         let user_id = [];
        if (this.selectedUsers.length) {
          user_id = this.selectedUsers.map((user_ids) => ({
            user_id: user_ids.user_id,
            username: user_ids.username,
          }));
        }
      let loader = this.$loading.show();
      let payload = {
        // cinema_id: this.dropDown.selectedCinema.map((cinemas) => {
        //   return cinemas.cine_id;
        // }),
        // cinema_name: this.dropDown.selectedCinema.map((cinemas) => {
        //   return cinemas.cine_name;
        // }),
        // cinema_address: this.dropDown.selectedCinema.map((cinemas) => {
        //   return cinemas.cine_address;
        // }),
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        excel: isExcel,
        isPdf: isPdf,
          start_time: this.start_time,
          end_time: this.end_time,
            user_id: user_id.map((p) => p.user_id),
          username: user_id.map((p) => p.username),
        store_id: this.selectedStores.map((x) => x.sm_id),
        store_name: this.selectedStores.map((x) => x.sm_store_name),
        payment_mode_id: this.selectedPaymentModes.map((x) => x.pm_id),
        payment_mode_name: this.selectedPaymentModes
          .map((x) => x.pm_payment_mode)
          .join(", "),
      };
      ReportsService.getConcessionItemSales(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.concessionItemRecords = [...data.Records];
            //console.log("concession",this.concessionItemRecords)

            this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/concessionItemSalesCategory.vue